
// Web Component: ReturnOrder
// Gestisce la logica per la richiesta di reso ordine, inclusi form, errori e loader.
// Attributi richiesti: presenza di theme-form, data-errors, data-errors-template, data-errors-container
// Dipendenze: Utils, theme-loader
// Limiti: richiede struttura HTML compatibile e dati JSON corretti
// Utilizzato nelle pagine di richiesta reso ordine
class ReturnOrder extends HTMLElement {
  form; loader; errors;

  connectedCallback() {
    this.form = this.querySelector('theme-form');
    this.errors = JSON.parse(this.querySelector('[data-errors]').innerHTML);
    this.errorsTemplate = this.querySelector('[data-errors-template]').innerHTML;
    this.errorsContainer = this.querySelector('[data-errors-container]');
    this.loader = document.querySelector('theme-loader[data-global]');
    this.init();
  }

  init = () => {
    this.form.addEventListener(Utils.E_FORM_SUBMIT, () => this.openLoader());
    this.form.addEventListener(Utils.E_FORM_SUCCESS, (e) => this.checkSubmit(e.detail));
    this.form.addEventListener(Utils.E_FORM_ERROR, (e) => this.error(e.detail.response.status));
    this.form.addEventListener(Utils.E_FORM_SENT, () => this.closeLoader());
  }

  checkSubmit = (data) => {
    if(data.shopify_order){
      this.deactivate();
      if(data.iban_required) {
        window.dispatchEvent(new CustomEvent(Utils.E_RETURN_IBAN, { detail: data }));
      } else {
        window.dispatchEvent(new CustomEvent(Utils.E_RETURN_ORDER, { detail: data }));
      }
    } else {
      this.error();
    }
  }

  error = (error) => {
    console.log(error);
    this.errorsContainer.innerHTML = this.errorsTemplate.replaceAll('{errorText}', this.errors.not_found);
  }

  openLoader = () => {
    this.loader.show();
  }

  closeLoader = () => {
    this.loader.hide();
  }

  deactivate = () => {
    this.classList.add('d-none');
  }
}
if (!customElements.get('return-order')) {
  customElements.define('return-order', ReturnOrder);
}

class ReturnRequest extends HTMLElement {
  static URL_SHOPS = `${Utils.API_URL}/api/fidelity/shops`;
  data; templates; form; selectors; shops;

  connectedCallback() {
    this.templates = this.querySelectorAll('[data-template]');
    window.addEventListener(Utils.E_RETURN_ORDER, (e) => this.activate(e.detail));
    window.addEventListener(Utils.E_RETURN_IBAN, (e) => this.activate(e.detail));
  }

  init = () => {
    this.form = this.querySelector('theme-form');
    this.selectors = this.querySelectorAll('quantity-selector');
    this.reasonSelect = this.querySelector('#return-reason');
    this.modeSelect = this.querySelector('#return-mode');
    this.shopSelect = this.querySelector('#return-shop');
    this.getShops();

    this.addOptions(this.reasonSelect, this.data.return_attributes.returnReasons);
    this.addOptions(this.modeSelect, this.data.return_attributes.returnModes);
    this.form.addEventListener(Utils.E_FORM_VALIDATE, () => this.checkData());
    this.form.addEventListener(Utils.E_FORM_SUBMIT, () => this.cleanData());
    this.form.addEventListener(Utils.E_FORM_SUCCESS, () => this.success());
    this.form.addEventListener(Utils.E_FORM_ERROR, () => this.error());

    this.modeSelect.addEventListener('change', () => {
      this.checkMode();
    });
  }

  checkMode = () => {
    const wrapper = this.shopSelect.closest('input-select');
    if(this.modeSelect.value === '3') {
      wrapper.classList.remove('d-none');
      wrapper.setRequired(true);
    } else {
      wrapper.classList.add('d-none');
      wrapper.setRequired(false);
    }
  }

  error = () => {
    this.querySelector('[data-error]').innerText = formErrors.generic;
  }

  success = () => {
    const data = {form: this.form.data, order: this.data.shopify_order};
    Shopify.analytics.publish(Utils.E_RETURN_CREATED, data);
    window.dispatchEvent(new CustomEvent(Utils.E_RETURN_CREATED, { detail: data }));
    Swal.fire({
      title: this.dataset.successTitle,
      text: this.dataset.successText,
      icon: 'success',
      confirmButtonText: this.dataset.successBtn,
      iconColor: 'var(--bs-success)',
      color: 'var(--bs-body-color)',
      background: 'var(--bs-body-bg)',
      customClass: {
        title: 'fs-5',
        confirmButton: 'btn btn-primary',
        container: 'fs-body',
        htmlContainer: 'fs-body'
      }
    }).then(() => {
      location.href = this.dataset.redirect;
    });
  }

  cleanData = () => {
    const items = [];
    this.form.data.return_line_items.forEach((item) => {
      if(item.quantity > 0) {
        items.push(item);
      }
    });
    this.form.data.return_line_items = items;
  }

  checkData = () => {
    const sum = Array.from(this.selectors).reduce((acc, selector) => acc + selector.value, 0);

    if(sum <= 0) {
      this.form.valid = false;
      this.querySelector('[data-error]').innerText = formErrors.required;
    } else {
      this.querySelector('[data-error]').innerText = '';
    }
  }

  render = () => {
    const template = this.getTemplate('main');
    this.innerHTML = template.replaceAll('{order_id}', this.data.shopify_order.legacyId)
      .replaceAll('{iban}', this.renderIban())
      .replaceAll('{items}', this.renderItems());
    this.init();
  }

  addOptions = (select, elements) => {
    elements.forEach((element) => {
      const option = document.createElement('option');
      option.value = element.code || element.shop_id.value;
      option.text = element.description || element.name;
      select.appendChild(option);
    });
  }

  renderIban = () => {
    if(this.data.iban_required) {
      const template = this.getTemplate('iban');
      return template;
    }
    return '';
  }

  renderItems = () => {
    const template = this.getTemplate('item');
    const templateReturned = this.getTemplate('returned-item');
    const ts = [];
    var i = 0;
    this.data.shopify_order.fulfillments.forEach((fulfillment) => {
      fulfillment.fulfillmentLineItems.nodes.forEach((item) => {
        ts.push((item.lineItem.currentQuantity > 0 ? template : templateReturned)
          .replaceAll('{title}', item.lineItem.title)
          .replaceAll('{variant}', item.lineItem.variantTitle)
          .replaceAll('{alt}', item.lineItem.title)
          .replaceAll('{options}', this.renderOptions(item.lineItem))
          .replaceAll('{max}', item.lineItem.currentQuantity)
          .replaceAll('{price}', Utils.money(item.discountedTotalSet.shopMoney.amount*100))
          .replaceAll('{amount}', item.discountedTotalSet.shopMoney.amount)
          .replaceAll('{index}', i)
          .replaceAll('{returned}', this.renderReturned(item))
          .replaceAll('{sku}', item.lineItem.sku || '')
          .replaceAll('{src}', (item.lineItem.image ? item.lineItem.image.url : this.dataset.placeholder))
          .replaceAll('{id}', item.legacyId)
        );
        i++;
      });
    });
    return ts.join('');
  }

  renderReturned = (item) => {
    const q = item.quantity - item.lineItem.currentQuantity;
    if(q > 0) {
      const template = this.getTemplate('returned');
      return template.replaceAll('{value}', q);
    }
    return '';
  }

  renderOptions = (item) => {
    const template = this.getTemplate('option');
    const ts = [];
    if(item.variant && item.variant.selectedOptions){
      item.variant.selectedOptions.forEach((option) => {
        if(option.name.toLowerCase() === 'title') return;
        ts.push(template
          .replaceAll('{name}', option.name)
          .replaceAll('{value}', option.value)
        );
      });
    }
    return ts.join('');
  }

  activate = (data) => {
    const excluded = this.dataset.excluded.split(',');
    const fulfillments = [];
    data.shopify_order.fulfillments.forEach(fulfillment => {
      const items = fulfillment.fulfillmentLineItems.nodes.filter(item => {
        return !excluded.includes(item.lineItem.title.toLowerCase());
      });
      if(items.length > 0){
        fulfillments.push({
          createdAt: fulfillment.createdAt,
          fulfillmentLineItems: {nodes: items},
          legacyId: fulfillment.legacyId,
          id: fulfillment.id,
          name: fulfillment.name
        });
      }
    });
    this.data = data;
    this.data.shopify_order.fulfillments = fulfillments;
    this.render();
    this.classList.remove('d-none');
  }

  getTemplate = (name) => { 
    const t = Array.from(this.templates).filter((template) => template.dataset.template === name);
    return t.length > 0 ? t[0].innerHTML : null;
  }

  getId = (str) => {
    return str.split('/').at(-1);
  }

  getShops = () => {
    axios({
      url: ReturnRequest.URL_SHOPS,
      method: 'GET'
    }).then((response) => {
      this.addOptions(this.shopSelect, response.data.filter(shop => {
        return shop.shop_id.value !== 'E2' && shop.shop_id.value !== 'XY';
      }));
    }).catch((error) => {
      console.log(error);
    });
  }
}
if (!customElements.get('return-request')) {
  customElements.define('return-request', ReturnRequest);
}

class ReturnItem extends HTMLElement {
  selector;

  connectedCallback() {
    this.selector = this.querySelector('quantity-selector');
    this.selector.addEventListener(Utils.E_QUANTITY_CHANGE, () => this.update());
  }

  update = () => {
    const quantity = this.selector.value;
    if(quantity > 0) {
      this.activate();
    } else {
      this.deactivate();
    }
  }

  activate = () => {
    this.classList.add('active');
  }

  deactivate = () => {
    this.classList.remove('active');
  }
}
if (!customElements.get('return-item')) {
  customElements.define('return-item', ReturnItem);
}

class ReturnList extends HTMLElement {
  url; templates; data; statuses;

  connectedCallback() {
    this.url = `${Utils.API_URL}/api/shop/${this.dataset.domain}/search-customer-returns`;
    this.templates = this.querySelectorAll('[data-template]');
    this.statuses = JSON.parse(this.querySelector('#return-statuses').innerText);
    this.searchOrders();
  }

  searchOrders = () => {
    axios({
      url: this.url,
      method: 'GET',
      params: {
        shopifyCustomerId: this.dataset.customer
      }
    }).then((response) => {
      this.data = response.data;
      this.render();
    }).catch((error) => {
      console.log(error);
    })
  }

  render = () => {
    console.log(this.data);
    if(this.data.length === 0){
      this.innerHTML = this.renderEmpty();
    } else {
      const ts = [];
      const template = this.getTemplate('list');
      this.data.forEach((order) => {
        ts.push(this.renderOrder(order));
      });
      this.innerHTML = template.replaceAll('{orders}', ts.join(''));
    }
  }

  renderEmpty = () => {
    const template = this.getTemplate('empty');
    return template;
  }

  renderOrder = (order) => {
    const template = this.getTemplate('order');
    return template.replaceAll('{{ name }}', order.name)
                    .replaceAll('{total}', Utils.money(1222)) //todo: metti il totale
                    .replaceAll('{url}', 'test') //todo: metti l'url
                    .replaceAll('{status}', this.statuses[order.returnStatus]);
  }

  getTemplate = (name) => { 
    const t = Array.from(this.templates).filter((template) => template.dataset.template === name);
    return t.length > 0 ? t[0].innerHTML : null;
  }

}
if (!customElements.get('return-list')) {
  customElements.define('return-list', ReturnList);
}

// gestisce i resi automatici di onestock
class ReturnOnestock extends HTMLElement {
  onestock; //div di onestock

  connectedCallback() {
    this.init();
  }

  sha256 = (message, callback) => {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);                    

    // hash the message
    crypto.subtle.digest('SHA-256', msgBuffer).then(hashBuffer => {
      // convert ArrayBuffer to Array
      const hashArray = Array.from(new Uint8Array(hashBuffer));

      // convert bytes to hex string                  

      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      callback(hashHex);
    });
}

  // aggiungo eventi e setto proprietà
  init = () => {
    // ascolto l'evento di selezione dell'ordine    
    window.addEventListener(Utils.E_RETURN_ORDER, (e) => this.render(e.detail));
  }

  //aggiungo il div di onestock in base all'ordine selezionato
  render = (data) => {
    this.sha256(`${data.shopify_order.legacyId}-EC6213d4ea-c6b5-490f-b8b9-2131406afa89`, (hash) => {
      this.onestock = document.createElement('div');
      this.onestock.id = 'self-service-return';
      this.onestock.dataset.orderId = `${data.shopify_order.legacyId}-EC`;
      this.onestock.dataset.hash = hash;
      this.onestock.dataset.lang = this.dataset.lang;
      this.appendChild(this.onestock);
      this.classList.remove('d-none');
  
      const script = document.createElement('script');
      script.src = 'https://pittarello-selfservicereturn.onestock-retail.io/build/ssr.js';
      this.appendChild(script);
    });
  }

}
if (!customElements.get('return-onestock')) {
  customElements.define('return-onestock', ReturnOnestock);
}

class ReturnIban extends HTMLElement {
  form; loader; errors; errorsTemplate; errorsContainer; orderInput; orderData;

  connectedCallback() {
    this.form = this.querySelector('theme-form');
    this.errors = JSON.parse(this.querySelector('[data-errors]').innerHTML);
    this.errorsTemplate = this.querySelector('[data-errors-template]').innerHTML;
    this.errorsContainer = this.querySelector('[data-errors-container]');
    this.loader = document.querySelector('theme-loader[data-global]');
    this.orderInput = this.querySelector('#return-iban-order');
    this.init();
  }

  init = () => {
    window.addEventListener(Utils.E_RETURN_IBAN, (e) => this.activate(e.detail));
    this.form.addEventListener(Utils.E_FORM_SUBMIT, () => this.openLoader());
    this.form.addEventListener(Utils.E_FORM_SUCCESS, (e) => this.continue(e.detail));
    this.form.addEventListener(Utils.E_FORM_ERROR, (e) => this.error(e.detail.response.status));
    this.form.addEventListener(Utils.E_FORM_SENT, () => this.closeLoader());
  }

  continue = (data) => {
    window.dispatchEvent(new CustomEvent(Utils.E_RETURN_ORDER, { detail: this.orderData }));
    this.deactivate();
  }

  error = (error) => {
    console.log(error);
    this.errorsContainer.innerHTML = this.errorsTemplate.replaceAll('{errorText}', this.errors.not_found);
  }

  openLoader = () => {
    this.loader.show();
  }

  closeLoader = () => {
    this.loader.hide();
  }

  deactivate = () => {
    this.classList.add('d-none');
  }

  activate = (data) => {
    this.orderData = data;
    this.orderInput.value = this.orderData.shopify_order.legacyId;
    this.classList.remove('d-none');
  }
}
if (!customElements.get('return-iban')) {
  customElements.define('return-iban', ReturnIban);
}